import type { ClaimsFeatureConfig } from '../../../types/features/ClaimsFeatureConfig';

export const claims: ClaimsFeatureConfig = {
    fetchClaimsWithoutFlag: true,
    showPageCaption: false,
    showClaimsSection: false,
};
